/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface LifecycleStage
 */
export interface LifecycleStage {
  /**
   *
   * @type {number}
   * @memberof LifecycleStage
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof LifecycleStage
   */
  name: string;
  /**
   *
   * @type {number}
   * @memberof LifecycleStage
   */
  order: number;
}

/**
 * Check if a given object implements the LifecycleStage interface.
 */
export function instanceOfLifecycleStage(value: object): value is LifecycleStage {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('order' in value) || value['order'] === undefined) return false;
  return true;
}

export function LifecycleStageFromJSON(json: any): LifecycleStage {
  return LifecycleStageFromJSONTyped(json, false);
}

export function LifecycleStageFromJSONTyped(json: any, ignoreDiscriminator: boolean): LifecycleStage {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    order: json['order'],
  };
}

export function LifecycleStageToJSON(value?: Omit<LifecycleStage, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    order: value['order'],
  };
}
